import { QuoteAnalyticsResponse } from '../types/analytics.types';

const API_BASE_URL = '/api/quote-analytics';

export const analyticsApi = {
  getQuoteConversionMetrics: async (): Promise<QuoteAnalyticsResponse> => {
    const response = await fetch(`${API_BASE_URL}/conversion-metrics`);
    if (!response.ok) {
      throw new Error(`Failed to fetch quote conversion metrics: ${response.statusText}`);
    }
    return response.json();
  },
};
